export class AtualizarNcmProdutoRequest {
  public idProduto: number = 0;
  public ncm: string = '';
}
